interface Step {
  title: string;
  description: string;
}

interface TimelineProps {
  title: string;
  subtitle: string;
  steps: Step[];
  isVisible: boolean;
}

export default function Timeline({ title, subtitle, steps, isVisible }: TimelineProps) {
  return (
    <section
      className="py-32 px-6 bg-gradient-to-b from-[var(--navy-deep)] to-[var(--navy-mid)]"
    >
      <div
        className={`max-w-6xl mx-auto transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-center">{title}</h2>
        <p className="text-xl text-gray-400 mb-16 text-center">{subtitle}</p>

        {/* Timeline */}
        <div className="relative flex flex-col md:flex-row justify-between items-center gap-8 md:gap-0">
          {/* Connection line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-[var(--cyan-electric)]/20 via-[var(--cyan-electric)] to-[var(--cyan-electric)]/20 -translate-y-1/2" />

          {steps.map((step, i) => (
            <div
              key={i}
              className="relative z-10 flex flex-col items-center transition-all duration-500 group"
              style={{
                transitionDelay: `${i * 150}ms`,
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              }}
            >
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[var(--cyan-electric)] to-cyan-400 flex items-center justify-center text-2xl font-bold text-[var(--navy-deep)] mb-4 shadow-lg shadow-cyan-500/30 group-hover:scale-110 transition-transform">
                {i + 1}
              </div>
              <span className="text-lg font-semibold mb-1">{step.title}</span>
              <span className="text-sm text-gray-500 text-center max-w-[150px] opacity-0 group-hover:opacity-100 transition-opacity">
                {step.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
